import {computed, Injectable, Signal, signal} from "@angular/core";
import {DokumentId} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {erIkkeNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";

const debug = initDebugger('ValgtDokumentRegister');

/** Tjeneste for å vedlikeholde og koordinere informasjon om valgt dokument.
 * Skrives til av {@link SakListeDokumenterKomponent} og leses av {@link SakListeOgDetaljerKomponent} */
@Injectable()
export class ValgtDokumentRegister {

    private readonly valgtDokument = signal<DokumentId | null>(null);

    constructor() {
    }

    setValgt(dokumentId: DokumentId): void {
        debug('setValgt', dokumentId);
        this.valgtDokument.set(dokumentId);
    }

    nullstillValgt(): void {
        this.valgtDokument.set(null);
    }

    get valgt(): Signal<DokumentId | null> {
        return this.valgtDokument.asReadonly();
    }

    get erNoenValgt(): Signal<boolean> {
        return computed(() => erIkkeNil(this.valgtDokument.asReadonly()));
    }
}
